import React from "react"
import { heatDataNew } from "../../data/heatData"
import { visibilityData } from "../../data/visibilityData"
import Heat from "../molecules/Heat"
import Visibility from "../molecules/Visibility"
import Rain from "../molecules/Rain"
import AirQuality from "../molecules/AirQuality"
import { mapLinear } from "three/src/math/MathUtils"
import { rainDataNew } from "../../data/rainData"
import { airDataNew } from "../../data/airData"

const mappedData = (dataObj, data, name) => {
  // Get the minimum and maximum values of the data
  const min = Math.min(...data.map((model) => model[name]))
  const max = Math.max(...data.map((model) => model[name]))
// Map the value to a range between 0 and 1
  return mapLinear(dataObj[name], min, max, 0, 1)
}

function Shapes() {

  return (
    <group>
      <group position={[1, -0.65, 0]}>
        {heatDataNew.map((model, i) => {
          return (
            <Heat
              key={i}
              xPos={i * 2}
              valueMaxTemp={mappedData(model, heatDataNew, "maxTemp")}
              valueSolarExposure={mappedData(model, heatDataNew, "solarExposure")}
            />
          )
        })}
      </group>
      <group position={[0, -0.65, 0]}>
        {visibilityData.map((model, i) => (
          <Visibility
            key={i}
            xPos={i * 2}
            valuePm10={mappedData(model, visibilityData, "pm10")}
            valueNeph={mappedData(model, visibilityData, "neph")}
          />
        ))}
      </group>
      <group position={[1, 0.6, 0]}>
        {rainDataNew.map((model, i) => (
          <Rain
            key={i}
            xPos={i * 2}
            valueRainfall={mappedData(model, rainDataNew, "rainfall")}
            valueElNino={mappedData(model, rainDataNew, "elNino")}
          />
        ))}
      </group>
      <group position={[0, 0.6, 0]}>
        {airDataNew.map((model, i) => (
          <AirQuality
            key={i}
            xPos={i * 2}
            valueOzone={mappedData(model, airDataNew, "ozone")}
            valueCo={mappedData(model, airDataNew, "co")}
          />
        ))}
      </group>
    </group>
  )
}

export default Shapes
